import React from 'react'
import ServiceCard from './ServiceCard'
import image1 from '../images/feature_1.png'
import image2 from '../images/feature_2.png'
import image3 from '../images/feature_3.png'


function Services() {
    return (
        <div id="services">
            <div className="s-heading">
                <h1>Our Services</h1>
                <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Soluta, molestias rerum recusandae vel voluptas nemo.
                </p>
                <div className="ServiceCard">
                <ServiceCard image={image1}/>
                <ServiceCard image={image2}/>
                <ServiceCard image={image3}/>
                </div>
            </div>
        </div>
    )
}

export default Services
